module.exports = __webpack_public_path__ + "static/media/about-us-hero-image.e3912bd8.webp";